import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormArray, FormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EHSExamsService } from '../../services/ehsExams-services';
import { TransactionResult } from '../../../../../core/services/interfaces/transaction-result';
import { IEHSExamsTypes } from '../../Interfaces/IEHSExamsTypes';
import { NotificationService } from 'src/app/core/services/notification/notification.service';
import { TranslateApplicationService } from 'src/app/core/translate/translate-application-service';
import { IEHSExams } from '../../Interfaces/IEHSExams';
import { IQuestions } from '../../Interfaces/IQuestions';
import { IAnswers } from '../../Interfaces/IAnswers';

declare var jQuery: any;

@Component({
	selector: 'app-ehs-exams-detail',
	templateUrl: './ehs-exams-detail.component.html',
	styleUrls: ['./ehs-exams-detail.component.scss'],
})
export class EHSExamsDetailComponent implements OnInit {
	loading: boolean = false;
	formGroup: FormGroup;
	listExamsTypes: Array<IEHSExamsTypes> = [];
	listQuestions: Array<IQuestions> = [];
	station: string = 'TABLE';
	columns: Array<any> = [
		'question',
		'optionA',
		'optionB',
		'optionC',
		'correctAnswer',
		'changestatuscolumn',
		'editcolumn',
	];

	max_characters_exam: string;
	max_characters_question: string;
  	max_characters_answer: string;
  	order: number = 0;
	MAX_POINTS_TO_PASS: number = 30;

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: IEHSExams,
		private dialogRef: MatDialogRef<EHSExamsDetailComponent>,
		private EHSExamsService: EHSExamsService,
		private formBuilder: FormBuilder,
		private notificationService: NotificationService,
		public translate: TranslateApplicationService,
	) {
		this.formGroup = this.formBuilder.group({
			pkehsexam: [data.pkehsexam == null ? 0 : data.pkehsexam],
			pkquestion: [0],
			pkanswers: [0],
			txtexamName: [
				data.examname,
				[
					Validators.required,
					Validators.maxLength(80),
					Validators.pattern('.*[a-zA-Z].*'),
				],
			],
			cbfktypeexam: [data.fkexamtype, Validators.required],
			txtexamTries: [
				data.tries,
				[Validators.required, Validators.pattern('^[0-9]*$')],
			],
			txtexamPointToPass: [
				data.pointtopass,
				[Validators.required, Validators.pattern('^[0-9]*$')],
			],
			txtexamQuestion: [
				'',
				[
					Validators.required,
					Validators.maxLength(255),
					Validators.pattern('.*[a-zA-Z].*'),
				],
			],
			answer: [''],
			chkcorrectAnswer: ['', Validators.required],
			txtehsFirstAnswer: [
				'',
				[
					Validators.required,
					Validators.maxLength(255),
					Validators.pattern('.*[^ ].*'),
				],
			],
			txtehsSecondAnswer: [
				'',
				[
					Validators.required,
					Validators.maxLength(255),
					Validators.pattern('.*[^ ].*'),
				],
			],
			txtehsThirdAnswer: [
				'',
				[
					Validators.required,
					Validators.maxLength(255),
					Validators.pattern('.*[^ ].*'),
				],
			],
			pkanswerA: [0],
			pkanswerB: [0],
			pkanswerC: [0],
			questionCount: [
				data.questionscount == null ? 0 : data.questionscount,
      		],
      		code: [""],
      		order: [0]
		});
	}

	ngOnInit(): void {
		jQuery('.questions button-add').hide();
		this.GetExamsTypes();
		this.GetQuestions();
		if (this.formGroup.controls.questionCount.value == 30) {
			jQuery('#addQuestion button-save').hide();
		}
		let max_char = this.translate.TranslateKey('max_characteres');
		this.max_characters_exam = max_char.replace('{{ number_max }}', '80');
		this.max_characters_question = max_char.replace(
			'{{ number_max }}',
			'255',
		);
		this.max_characters_answer = max_char.replace(
			'{{ number_max }}',
			'255',
    	);
	}

	Alert(title: string, message: string) {
		this.notificationService.AddAlert({
			icon: 'all_inbox',
			title: title,
			message: this.translate.TranslateKey(message),
			shown: true,
		});
	}

	Close() {
		this.dialogRef.close(true);
	}

	EditQuestion(item: IQuestions) {
		this.loading = true;
		this.formGroup.controls.pkquestion.setValue(item.pkquestion);
		this.formGroup.controls.txtexamQuestion.setValue(item.question);
		this.formGroup.controls.chkcorrectAnswer.setValue(item.correctAnswer);
		this.formGroup.controls.txtehsFirstAnswer.setValue(item.optionA);
		this.formGroup.controls.txtehsSecondAnswer.setValue(item.optionB);
		this.formGroup.controls.txtehsThirdAnswer.setValue(item.optionC);
		this.formGroup.controls.pkanswerA.setValue(item.pkanswerA);
		this.formGroup.controls.pkanswerB.setValue(item.pkanswerB);
		this.formGroup.controls.pkanswerC.setValue(item.pkanswerC);
		this.loading = false;
	}

	GetExamsTypes() {
		this.loading = true;
		this.EHSExamsService.GetExamTypes().subscribe(
			(result: TransactionResult<IEHSExamsTypes[]>) => {
				if (result.success) {
					this.listExamsTypes = result.data;
					this.loading = false;
				}
				else{
					this.loading = false;
					this.ErrorAlert(result.message);
				}
			},
			(error)=> {
				this.ErrorAlert(error);
				this.loading = false;
			});
	}

	GetQuestions() {
		this.loading = true;
		this.EHSExamsService.GetQuestionsAnswers( this.formGroup.value ).subscribe(
		(result: TransactionResult<IQuestions[]>) => {
			if (result.success) {
				this.loading = false;
				this.listQuestions = result.data;
			}
			else{
				this.loading = false;
				this.ErrorAlert(result.message);
			}
		},
		(error) => {
			this.loading = false;
			this.ErrorAlert(error);
		});
	}

 	Anwers() {
		this.loading = true;
		if (this.formGroup.controls.pkanswerA.value == 0) {
			this.order = this.order + 1;
			this.formGroup.controls.order.setValue(this.order);
			this.formGroup.controls.answer.setValue(
				this.formGroup.controls.txtehsFirstAnswer.value,
			);
			this.CreateAnswers();
			this.order = this.order + 1;
			this.formGroup.controls.order.setValue(this.order);
			this.formGroup.controls.answer.setValue(
				this.formGroup.controls.txtehsSecondAnswer.value,
			);
			this.CreateAnswers();
			this.order = this.order + 1;
			this.formGroup.controls.order.setValue(this.order);
			this.formGroup.controls.answer.setValue(
				this.formGroup.controls.txtehsThirdAnswer.value,
			);
			this.CreateAnswers();
			this.Alert(
				'Success',
				'Question_answer_saved_successfully',
			);
			this.loading = false;
		} 
		else {
			this.order = this.order + 1;
			this.formGroup.controls.order.setValue(this.order);
			this.formGroup.controls.pkanswers.setValue(
				this.formGroup.controls.pkanswerA.value,
			);
			this.formGroup.controls.answer.setValue(
				this.formGroup.controls.txtehsFirstAnswer.value,
			);
			this.UpdateAnswers();
			this.order = this.order + 1;
			this.formGroup.controls.order.setValue(this.order);
			this.formGroup.controls.pkanswers.setValue(
				this.formGroup.controls.pkanswerB.value,
			);
			this.formGroup.controls.answer.setValue(
				this.formGroup.controls.txtehsSecondAnswer.value,
			);
			this.UpdateAnswers();
			this.order = this.order + 1;
			this.formGroup.controls.order.setValue(this.order);
			this.formGroup.controls.pkanswers.setValue(
				this.formGroup.controls.pkanswerC.value,
			);
			this.formGroup.controls.answer.setValue(
				this.formGroup.controls.txtehsThirdAnswer.value,
			);
			this.UpdateAnswers();
			this.Alert(
				'Success',
				'COMPLETE',
			);
			this.loading = false;
		}
		this.ClearQuestionAnswers();
	}

	ClearQuestionAnswers() {
		this.loading = true;
		this.formGroup.controls.txtexamQuestion.setValue('');
		this.formGroup.controls.txtehsFirstAnswer.setValue('');
		this.formGroup.controls.txtehsSecondAnswer.setValue('');
		this.formGroup.controls.txtehsThirdAnswer.setValue('');
		this.formGroup.controls.chkcorrectAnswer.setValue('');
		this.order = 0;
		this.formGroup.controls.order.setValue(this.order);
		this.loading = false;
	}

	CreateAnswers() {
		this.loading = true;
		this.EHSExamsService.CreateAnswer(this.formGroup.value).subscribe(
		(result: TransactionResult<IAnswers[]>) => {
			if (result.success) {
				this.GetQuestions();
				this.formGroup.controls.pkquestion.setValue(0);
				this.loading = false;
			}
			else{
				this.ErrorAlert(result.message);
				this.loading = false;
			}
		},
		(error) => {
			this.ErrorAlert(error);
			this.loading = false;
		});
	}

	UpdateAnswers() {
		this.loading = true;
		this.EHSExamsService.UpdateAnswer(this.formGroup.value).subscribe(
		(result: TransactionResult<IAnswers[]>) => {
			if (result.success) {
				this.GetQuestions();
				this.loading = false;
			}
			else{
				this.ErrorAlert(result.message);
				this.loading = false;
			}
		},
		(error) => {
			this.ErrorAlert(error);
			this.loading = false;
		});
	}

	Save() {
		this.loading = true;
		if (this.formGroup.valid) {
			if (this.formGroup.controls.pkehsexam.value == 0) {
				// create exam and save question
				if(Number(this.formGroup.controls.txtexamTries.value) <= 0){
					this.Alert('Warning', 'WARNINGS.EHS_Tries_warnings');
					this.loading = false;
				} 
				else if(Number(this.formGroup.controls.txtexamPointToPass.value) > this.MAX_POINTS_TO_PASS){
					this.Alert('Warning', 'WARNINGS.EHS_Max_Points_warnings');
					this.loading = false;
				}
				else if(Number(this.formGroup.controls.txtexamPointToPass.value) <= 0){
					this.Alert('Warning', 'WARNINGS.EHS_Points_warnings');
					this.loading = false;
				} else{
					this.EHSExamsService.CreateExam(this.formGroup.value).subscribe(
						(result: TransactionResult<IEHSExams>) => {
							if (result.success) {
								this.formGroup.controls.pkehsexam.setValue(
									result.data[0].pkehsexam
								);
								let answerA = this.formGroup.controls.txtehsFirstAnswer.value;
								let answerB = this.formGroup.controls.txtehsSecondAnswer.value;
								let answerC = this.formGroup.controls.txtehsThirdAnswer.value;
								if ( answerA == answerB || answerA == answerC || answerB == answerC ) {
                  this.loading = false;
                  this.Alert('Warning', 'WARNINGS.Duplicate_answer');
								} 
								else {
									this.EHSExamsService.CreateQuestion( this.formGroup.value ).subscribe(
									( result: TransactionResult<IQuestions[]>) => {
										this.loading = false;
                    if (result.success) {
											this.formGroup.controls.pkquestion.setValue(
												result.data[0].pkquestion,
											);
											this.Anwers();
											this.loading = false;
										}
									},
									(error) => {
										this.ErrorAlert(error);
										this.loading = false;
									});
								}
							}
						},
						(error: any) => { 
							this.ErrorAlert(error); this.loading = false;
						});
				}
			} 
			else {
				if (this.formGroup.controls.pkquestion.value == 0) {
					let answerA = this.formGroup.controls.txtehsFirstAnswer.value;
					let answerB = this.formGroup.controls.txtehsSecondAnswer.value;
					let answerC = this.formGroup.controls.txtehsThirdAnswer.value;
					if ( answerA == answerB || answerA == answerC || answerB == answerC ) {
            this.loading = false;
            this.Alert('Warning', 'WARNINGS.Duplicate_answer');
					} else {
						this.EHSExamsService.CreateQuestion( this.formGroup.value ).subscribe(
						(result: TransactionResult<IQuestions[]>) => {
              this.loading = false;
							if (result.success) {
								this.formGroup.controls.pkquestion.setValue(
									result.data[0].pkquestion,
								);
								this.Anwers();
								this.loading = false;
							}
						},
						(error) => {
							this.ErrorAlert(error);
							this.loading = false;
						});
					}
				} 
				else {
          			let answerA = this.formGroup.controls.txtehsFirstAnswer.value;
					let answerB = this.formGroup.controls.txtehsSecondAnswer.value;
					let answerC = this.formGroup.controls.txtehsThirdAnswer.value;
					if (answerA == answerB || answerA == answerC || answerB == answerC ) {
						this.Alert('Warning', 'WARNINGS.Duplicate_answer');
						this.loading = false;
					} 
					else {
						this.EHSExamsService.UpdateQuestion(this.formGroup.value).subscribe(
						(result: TransactionResult<IQuestions[]>) => {
							this.loading = false;
              if (result.success) {
								this.formGroup.controls.pkquestion.setValue(
									result.data[0].pkquestion,
                );
								this.Anwers();
								this.GetQuestions();
								this.loading = false;
							}
							else{
								this.ErrorAlert(result.message);
								this.loading = false;
							}
						},
						(error) => {
							this.ErrorAlert(error);
							this.loading = false;
						});
					}
				}
			}
		} 
		else {
			this.Alert('Warning', 'WARNINGS.Empty_fields');
			this.loading = false;
		}
	}

	ChangeStatus(item: IQuestions) {
		this.EHSExamsService.EnableDisableQuestion(item).subscribe(
		(result: TransactionResult<Boolean>) => {
			this.loading = false;
			if (result.success) {
				this.Alert(
					'Success',
					this.translate.TranslateKey('COMPLETE'),
				);
				this.GetQuestions();
			} else {
				this.Alert(
					'Warning',
					this.translate.TranslateKey('WARNING.Failed_updated_status'),
				);
			}
		},
		(error: any) => { this.ErrorAlert(error); this.loading = false; });
	}

	UpdateExam() {
		this.loading = true;
		if (this.formGroup.controls.txtexamName.value != '' && this.formGroup.controls.cbfktypeexam.value != null
		&& this.formGroup.controls.txtexamTries.value != '' && this.formGroup.controls.txtexamPointToPass.value != '') 
		{
			if(Number(this.formGroup.controls.txtexamTries.value) <= 0){
				this.Alert('Warning', 'WARNINGS.EHS_Tries_warnings');
				this.loading = false;
			} 
			else if(Number(this.formGroup.controls.txtexamPointToPass.value) > this.MAX_POINTS_TO_PASS){
				this.Alert('Warning', 'WARNINGS.EHS_Max_Points_warnings');
				this.loading = false;
			}
			else if(Number(this.formGroup.controls.txtexamPointToPass.value) <= 0){
				this.Alert('Warning', 'WARNINGS.EHS_Points_warnings');
				this.loading = false;
			}
			else{
				this.EHSExamsService.UpdateExam(this.formGroup.value).subscribe(
					(result: TransactionResult<boolean>) => {
						if (result.success) {
							this.Alert('Success', 'COMPLETE');
							this.loading = false;
							this.Close();
						} else {
							//this.Alert('Warning', 'DUPLICATE');
							this.loading = false;
						}
					},
					(error) => {
						this.ErrorAlert(error);
						this.loading = false;
					});
			}
			
		}
		else {
			this.Alert('Warning', 'WARNINGS.Empty_fields');
			this.loading = false;
		}
	}

  	ErrorAlert(message: any) {
		this.notificationService.AddAlert({
			icon: 'all_inbox',
			title: 'Error',
			message: message,
			shown: true,
		});
	}
}
